<template>
	<vuestic-sidebar :hidden="isOpen">

		<template slot="menu">

			<sidebar-link-group v-if="checkRoleProcesses(role)">

				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-book"></span>
					<span>{{ $t('menu.processes') }}</span>
				</span>

        <sidebar-link :to="{ name: 'processes-list' }">
					<span slot="title">
						<span>{{ $t('menu.protestLetter') }}</span>
					</span>
        </sidebar-link>

        <sidebar-link :to="{ name: 'request-reimbursement-list' }">
					<span slot="title">
						<span>{{ $t('menu.requestReimbursement') }}</span>
					</span>
        </sidebar-link>

				<!-- <sidebar-link :to="{ name: 'processes-draft' }">
					<span slot="title">
						<span>{{ $t('menu.draft') }}</span>
					</span>
				</sidebar-link> -->

				<!-- <sidebar-link :to="{ name: 'login' }" v-if="checkRoleinspector()">
					<span slot="title">
						<span>{{ $t('menu.refund') }}</span>
					</span>
				</sidebar-link> -->

			</sidebar-link-group>

			<!-- <sidebar-link-group>

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-cogs"></span>
					<span>{{ $t('menu.administration') }}</span>
				</span>


				<sidebar-link :to="{ name: 'login' }">
					<span slot="title">
						<span>{{ $t('administration.registerDepartment') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'login' }">
					<span slot="title">
						<span>{{ $t('administration.auxiliaryTables') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'login' }">
					<span slot="title">
						<span>{{ $t('administration.audit') }}</span>
					</span>
				</sidebar-link>

			</sidebar-link-group> -->

			<sidebar-link-group v-if="checkRoleusers(role)">
				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-users"></span>
					<span>{{ $t('menu.users') }}</span>
				</span>
				<sidebar-link :to="{ name: 'users-list' }">
					<span slot="title">
						<span>{{ $t('menu.list') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'users-new' }">
					<span slot="title">
						<span>{{ $t('menu.register') }}</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="checkRoleClients(role)">
				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-address-book"></span>
					<span>{{ $t('menu.clients') }}</span>
				</span>

				<sidebar-link :to="{ name: 'client-list' }">
					<span slot="title">
						<span>{{ $t('menu.list') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'client-new' }" v-if="checkRoleCBMaster(role)">
					<span slot="title">
						<span>{{ $t('menu.register') }}</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="checkRoleCustomBroker(role)">
				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-book"></span>
					<span>{{ $t('menu.customBroker') }}</span>
				</span>

				<sidebar-link :to="{ name: 'custom-broker-list' }">
					<span slot="title">
						<span>{{ $t('menu.list') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'custom-broker-new' }">
					<span slot="title">
						<span>{{ $t('menu.register') }}</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="checkRoleClaims(role) || checkRoleMaster(role)">
				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-anchor"></span>
					<span>{{ $t('menu.ports') }}</span>
				</span>

				<sidebar-link :to="{ name: 'port-list' }">
					<span slot="title">
						<span>{{ $t('menu.list') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'port-new' }">
					<span slot="title">
						<span>{{ $t('menu.register') }}</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="checkRoleClaims(role) || checkRoleMaster(role)">
				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-exclamation-circle"></span>
					<span>Causas de sinistro</span>
				</span>

				<sidebar-link :to="{ name: 'cause-list' }">
					<span slot="title">
						<span>{{ $t('menu.list') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'cause-new' }">
					<span slot="title">
						<span>{{ $t('menu.register') }}</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="checkRoleClaims(role) || checkRoleMaster(role)">
				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-ship"></span>
					<span>{{ $t('menu.vessels') }}</span>
				</span>

				<sidebar-link :to="{ name: 'vessel-list' }">
					<span slot="title">
						<span>{{ $t('menu.list') }}</span>
					</span>
				</sidebar-link>

				<sidebar-link :to="{ name: 'vessel-new' }">
					<span slot="title">
						<span>{{ $t('menu.register') }}</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

      <sidebar-link-group v-if="checkRoleClaims(role) || checkRoleMaster(role)">
				<span slot="title">
					<span class="fa sidebar-menu-item-icon fa-pie-chart"></span>
					<span>{{ $t('menu.reports') }}</span>
				</span>

        <sidebar-link :to="{ name: 'monthly-report' }">
					<span slot="title">
						<span>{{ $t('menu.monthlyReport') }}</span>
					</span>
        </sidebar-link>

        <sidebar-link :to="{ name: 'open-processes-report' }">
					<span slot="title">
						<span>{{ $t('menu.openProcessesReport') }}</span>
					</span>
        </sidebar-link>

        <sidebar-link :to="{ name: 'claims-closed-report' }">
					<span slot="title">
						<span>{{ $t('menu.claimsProcesses') }}</span>
					</span>
        </sidebar-link>

      </sidebar-link-group>

			<!-- <sidebar-link :to="{ name: 'manual' }">
				<span slot="title"> -->
					<!-- <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dashboard"></span> -->
					<!-- <span class="fa sidebar-menu-item-icon fa-question-circle"></span>
					<span>{{ $t('menu.manual') }}</span>
				</span>
			</sidebar-link> -->

		</template>
	</vuestic-sidebar>
</template>

<script>

import VuesticSidebar from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
import SidebarLink from './components/SidebarLink'
import SidebarLinkGroup from './components/SidebarLinkGroup'
import { globalStore } from '@/services/userService'

export default {
	name: 'app-sidebar',
	components: {
		VuesticSidebar,
		SidebarLink,
		SidebarLinkGroup
	},
	data () {
		return {
			// owner : globalStore.isOwner()
			role : globalStore.getRole()
		}
	},
	props: {
		isOpen: {
			type: Boolean,
			required: true
		}
	},
	methods: {
		checkRoleusers : function (role) {
			switch(role){
				case 'ROLE_MASTER':
					return true
					break;
				case 'ROLE_CLIENT_MASTER':
					return true
					break;
				case 'ROLE_CLAIMS':
					return true
					break;
				default:
					return false;
			}
		},
		checkRoleCustomBroker : function (role) {
			switch(role){
				case 'ROLE_MASTER':
					return true
					break;
				case 'ROLE_CLAIMS':
					return true
					break;
				case 'ROLE_CLIENT_MASTER':
					return true
					break;
				default:
					return false;
			}

		},
		checkRoleClients : function (role) {
			switch(role){
				case 'ROLE_MASTER':
					return true
					break;
				case 'ROLE_CLAIMS':
					return true
					break;
				case 'ROLE_CUSTOMS_BROKER_MASTER':
					return true
					break;
				default:
					return false;
			}
		},
		checkRoleCBMaster : function (role) {
			switch(this.role){
				case 'ROLE_CUSTOMS_BROKER_MASTER':
					return false
					break;
				default:
					return true;
			}
		},
		checkRoleCBOperator : function (role) {
			switch(role){
				case 'ROLE_CUSTOMS_BROKER_OPERATOR':
					return false
					break;
				default:
					return true;
			}
		},
		checkRoleProcesses : function (role) {
			switch(role){
				case 'ROLE_MASTER':
					return true
					break;
				case 'ROLE_CLAIMS':
					return true
					break;
				case 'ROLE_CLIENT_MASTER':
					return true
					break;
				case 'ROLE_CLIENT_OPERATOR':
					return true
					break;
				case 'ROLE_CUSTOMS_BROKER_MASTER':
					return true
					break;
				case 'ROLE_CUSTOMS_BROKER_OPERATOR':
					return true
				case 'ROLE_INSPECTOR':
					return true
					break;
        case 'ROLE_CUSTOMER_SERVICE':
          return true
          break;
				default:
					return false;
			}
		},
		checkRoleinspector : function (role) {
			switch(this.role){
				case 'ROLE_INSPECTOR':
					return false
					break;
				default:
					return true;
			}
		},
		checkRoleClaims : function (role) {
			switch(this.role){
				case 'ROLE_CLAIMS':
					return true
					break;
				default:
					return false;
			}
		},
		checkRoleMaster : function (role) {
			switch(this.role){
				case 'ROLE_MASTER':
					return true
					break;
				default:
					return false;
			}
		},

	},
	computed : {
	},
	created () {
	}
}

</script>



// WEBPACK FOOTER //
// src/components/admin/app-sidebar/AppSidebar.vue